import { SupportTicketService } from "@/ServerTypes/Administration/SupportTicketService";
import { alertDialog, Authorization, DialogTexts, ErrorHandling, Fluent, htmlEncode, notifyError, notifySuccess } from "@serenity-is/corelib";

ErrorHandling.showServiceError = function (error: any) {
    var id = 'ErrorDialog_' + new Date().getTime();

    function getSiteExternalUrl() {
        return window.location.href.split('/').slice(0, 3).join('/');
    }

    function removeEventListeners(el: HTMLElement) {
        const elClone = el.cloneNode(true) as HTMLElement;
        el.parentNode?.replaceChild(elClone, el);
        return elClone;
    }

    let msg: string;
    let errorDetails: string;
    if (error == null) {
        msg = '??ERROR??';
        errorDetails = '';
    }
    else {
        msg = error.Message;
        if (msg == null) {
            msg = error.Code;
        }
        errorDetails = `Error Id:${error.ErrorId}. Details:${error.Details}`;
    }

    alertDialog(`${error?.Details ? `<ul class="nav nav-tabs" role="tablist">
  <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#${id}_Error">Error</a></li>
  <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#${id}_Details">Details</a></li>
</ul>` : ''}
<div class="tab-content">
  <div id="${id}_Error" class="tab-pane fade show active error-pane">
    <div class="message-text">${htmlEncode(msg)}</div>
  </div>

  ${error?.Details ? `<div id="${id}_Details" class="tab-pane fade details">${htmlEncode(errorDetails)}</div>` : ''}


</div>`, <any>{
        modalClass: "s-AlertDialog s-MatrixErrorDialog",
        htmlEncode: false,
        size: "lg",
        width: '60%',
        onOpen: function () {
            var uidlg = Fluent(this).findFirst('.modal-content');
            uidlg.findFirst(".message").style(x => x.overflowX = "auto");
            removeEventListeners(uidlg.findFirst('.copy-button')[0]);
            uidlg.findFirst('.copy-button').on("click", () => {
                var copyCommand = null;
                if (navigator.clipboard)
                    copyCommand = (s: string) => navigator.clipboard.writeText(s);

                if (!copyCommand && (document as any).queryCommandSupported('copy')) {
                    copyCommand = (s: string) => {
                        var fakeElement = document.createElement('textarea');
                        fakeElement.style.position = 'absolute';
                        fakeElement.style.left = '-9999px';
                        fakeElement.style.top = (window.scrollY || document.documentElement.scrollTop) + 'px';
                        fakeElement.setAttribute('readonly', '');
                        fakeElement.value = s;
                        document.body.append(fakeElement);
                        fakeElement.select();
                        (document as any).execCommand("copy");
                        fakeElement.remove();
                    }
                }

                if (!copyCommand) {
                    notifyError("Copy to clipboard is not supported");
                    return;
                }
                var txt = uidlg.findFirst('.tab-pane').text();
                try {
                    copyCommand(txt);
                    notifySuccess("Copied error to clipboard.");
                } catch (error) {
                    notifyError("Sorry, an error occurred while trying to copy to the clipboard");
                }
            });

            var font = "font-family: Tahoma, Arial, Helvetica; font-size: 13px;";

            removeEventListeners(uidlg.findFirst('.ticket-button')[0]);
            uidlg.findFirst('.ticket-button').on("click", () => {
                SupportTicketService.SendEmail({
                    Subject: 'Matrix Portal Error Support Request',
                    Body: `<html>
<body style="${font}">
    <p style="${font}"><b>URL:</b> ${htmlEncode(window.location)}</p>
    <p></p>
    <p style="${font}"><b>Username:</b> ${Authorization.username}</p>
    <p></p>
    <p style="${font}"><b>Error ID: </b><a href="${htmlEncode(getSiteExternalUrl())}/Administration/ExceptionLog/info?guid=${htmlEncode(encodeURIComponent(error.ErrorId))}">${htmlEncode(error.ErrorId)}</a></p>
    <p></p>
    <p style="${font}">
        <b>Message:</b><br/>
        <pre style="${font}">${htmlEncode((error as any)?.Message)}</pre>
    </p>
    <p style="${font}"><b>Details:</b><br/>
<pre>${htmlEncode((error as any)?.Details)}</pre>
    </p>
</body>
</html>`
                },
                    () => {
                        notifySuccess('Details of the error have been emailed to the support team.');
                        (Fluent(this) as any).modal('hide');
                    });
            });
        },
        buttons: [
            {
                text: 'Copy',
                cssClass: 'copy-button'
            },
            {
                text: 'Open Support Ticket',
                cssClass: 'ticket-button',
            },
            {
                text: DialogTexts.OkButton,
                result: 'ok'
            }
        ]
    });

}